var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9888 20.2427C30.4374 20.2427 30.8678 20.4207 31.1851 20.7378C31.5023 21.055 31.681 21.4855 31.6812 21.9341V28.9985H38.7456C39.1943 28.9985 39.6246 29.1774 39.9419 29.4946C40.2592 29.8119 40.4379 30.2422 40.438 30.6909C40.438 31.1396 40.2592 31.5699 39.9419 31.8872C39.6246 32.2045 39.1944 32.3833 38.7456 32.3833H31.6812V39.4478C31.6812 39.8965 31.5024 40.3267 31.1851 40.644C30.8677 40.9613 30.4375 41.1401 29.9888 41.1401C29.5401 41.1401 29.1098 40.9613 28.7925 40.644C28.4752 40.3267 28.2964 39.8965 28.2964 39.4478V32.3833H21.2319C20.7833 32.3832 20.3529 32.2044 20.0356 31.8872C19.7185 31.5699 19.5405 31.1395 19.5405 30.6909C19.5406 30.2423 19.7184 29.8119 20.0356 29.4946C20.3529 29.1774 20.7833 28.9987 21.2319 28.9985H28.2964V21.9341C28.2965 21.4855 28.4752 21.055 28.7925 20.7378C29.1098 20.4206 29.5401 20.2427 29.9888 20.2427Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.465407
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.609232a7902c38c6dbab9adc4cb6bd13.svg";
export { ForwardRef as ReactComponent };